import { getMessaging } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDstXQp2pn_WStkXwW8MURasJJHe70lI9o",
    authDomain: "puretouch-b9b46.firebaseapp.com",
    projectId: "puretouch-b9b46",
    storageBucket: "puretouch-b9b46.firebasestorage.app",
    messagingSenderId: "547642487809",
    appId: "1:547642487809:web:6bbb309309b37bd8e47c00",
    measurementId: "G-4CB1PRPF16"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const messaging = getMessaging(app);